import { render, staticRenderFns } from "./PasswordColorPicker.vue?vue&type=template&id=ebf2f5ce&"
import script from "./PasswordColorPicker.vue?vue&type=script&lang=js&"
export * from "./PasswordColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports